export const share = () => (
  <svg width='21' height='21' viewBox='0 0 21 21' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path
      d='M15.75 11.375V16.625C15.75 17.0891 15.5656 17.5342 15.2374 17.8624C14.9092 18.1906 14.4641 18.375 14 18.375H4.375C3.91087 18.375 3.46575 18.1906 3.13756 17.8624C2.80937 17.5342 2.625 17.0891 2.625 16.625V7C2.625 6.53587 2.80937 6.09075 3.13756 5.76256C3.46575 5.43437 3.91087 5.25 4.375 5.25H9.625'
      stroke='#1F1F24'
      stroke-width='1.63447'
      stroke-linecap='round'
      stroke-linejoin='round'
    />
    <path d='M13.125 2.625H18.375V7.875' stroke='#1F1F24' stroke-width='1.63447' stroke-linecap='round' stroke-linejoin='round' />
    <path d='M8.75 12.25L18.375 2.625' stroke='#1F1F24' stroke-width='1.63447' stroke-linecap='round' stroke-linejoin='round' />
  </svg>
);
